<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindowSA">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["QRC"][obj_qr.I > 0? "EQC": "AQC"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" id="QRcodeS">
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2" @click="showSectionBasedRole('bi')"><span>1</span>{{this.getLanguage["QRC"]["BDI"]}} <i :class="setCollapseExpandIcon('BI')"></i> </h6>
                                        </CCol>
                                    </CRow>
                                    <template v-if="bool_showBI">
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["PM"]["AGI"]}}<span class="required" /> </label>
                                                <small class="d-block">{{this.utilGetDDLanguage('GL.AGT')}} </small>
                                            </CCol>
                                            <CCol col="5">
                                                <customtreeselect :multiple="false"
                                                                  :options="dd_agentgroup"
                                                                  :flat="true"
                                                                  :defaultExpandLevel="Infinity"
                                                                  :clearable="false"
                                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                                  v-model="obj_qr.AGIT"
                                                                  @input="AgentGroupChange"
                                                                  :disabled="obj_qr.I > 0"
                                                                  ref="AGIT" />
                                                <span class="ErrMsg">{{ ValidationErrMsg('AGIT','AGI') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["GL"]["SAGT"]}} </label>
                                                <small class="d-block">{{this.utilGetDDLanguage('GL.SAGT')}} </small>
                                            </CCol>
                                            <CCol col="5">
                                                <customtreeselect :multiple="false"
                                                                  :async="true"
                                                                  :flat="true"
                                                                  :key="rtSubBrand"
                                                                  :load-options="loadSubBrandOptions"
                                                                  :cacheOptions="false"
                                                                  :options="dd_subagentgroup"
                                                                  :defaultOptions="dd_DefaultSubBrand"
                                                                  :disable-branch-nodes="true"
                                                                  :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                                  :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                                                  :noResultsText="this.getLanguage['GL']['NRF']"
                                                                  v-model="obj_qr.SAGAGI"
                                                                  @input="SubAgentGroupChange"
                                                                  openDirection="below"
                                                                  :disabled="obj_qr.I > 0" />
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["QRC"]["D"]}}<span class="required" /> </label>
                                                <small class="d-block">{{this.utilGetDDLanguage('QRC.D')}} </small>
                                            </CCol>
                                            <CCol col="5">
                                                <treeselect :multiple="false"
                                                            :options="dd_do"
                                                            :placeholder="this.utilGetDDLanguage('QRC.D')"
                                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                                            @input="DomainChange"
                                                            v-model="obj_qr['DI']"
                                                            ref="DI" />
                                                <span class="ErrMsg">{{ ValidationErrMsg('DI','D') }}</span>
                                            </CCol>
                                        </CRow>
                                    </template>
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2" @click="showSectionBasedRole('sma')"><span>2</span>{{this.getLanguage["QRC"]["SMA"]}} <i :class="setCollapseExpandIcon('SMA')"></i> </h6>
                                        </CCol>
                                    </CRow>
                                    <template v-if="bool_showSMA">
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">
                                                    {{this.getLanguage["QRC"]["S"]}}
                                                    <div class="custom_tooltip">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement" style="left: 100px !important;">{{getLanguage["QRC"]["SINFO"]}}</span>
                                                    </div>
                                                    <span class="required" />
                                                </label>
                                            </CCol>
                                            <CCol col="5">
                                                <label class="switch">
                                                    <input type="checkbox" :checked="bool_obj_qrRS" @change="v => bool_obj_qrRS = v.target.checked">
                                                    <span class="slider round"></span>
                                                </label>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["QRC"]["L"]}}<span class="required" /> </label>
                                                <small class="d-block">{{this.getLanguage["QRC"]["LD"]}} </small>
                                            </CCol>
                                            <CCol col="5">
                                                <treeselect :multiple="true"
                                                            :options="dd_language"
                                                            :placeholder="this.utilGetDDLanguage('QRC.L')"
                                                            valueConsistsOf="LEAF_PRIORITY"
                                                            :defaultExpandLevel="Infinity"
                                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                                            v-model="obj_qr['arry_holdLang']"
                                                            :limit="3"
                                                            :limitText="count => `+${count}`"
                                                            ref="arry_holdLang">
                                                </treeselect>
                                                <span class="ErrMsg">{{ ValidationErrMsg('arry_holdLang','L') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["QRC"]["T"]}}<span class="required" /> </label>
                                                <small class="d-block">{{this.utilGetDDLanguage('QRC.T')}} </small>
                                            </CCol>
                                            <CCol col="5">
                                                <treeselect :multiple="false"
                                                            :options="dd_qrt"
                                                            :placeholder="this.utilGetDDLanguage('QRC.T')"
                                                            v-model="obj_qr['QRT']"
                                                            @input="qrcodeChange"
                                                            ref="QRT" />
                                                <span class="ErrMsg">{{ ValidationErrMsg('QRT','T') }}</span>
                                            </CCol>
                                        </CRow>
                                        <!--<label class="col-form-label-sm font-weight-bold">
            {{this.getLanguage["QRC"]["SD"]}}
            <div class="custom_tooltip">
                <i class="fa fa-question-circle"></i>
                <span class="tooltiptext2 turnover-requirement" style="left: 100px !important;">{{getLanguage["QRC"]["SDINFO"]}}</span>
            </div>
        </label>
        <label class="switch">
            <input type="checkbox" :checked="bool_obj_qrSD" @change="v => bool_obj_qrSD = v.target.checked">
            <span class="slider round"></span>
        </label>-->
                                        <CRow class="mx-3" v-if="obj_qr['QRT'] == 0 || obj_qr['QRT'] == 1 || obj_qr['QRT'] == 4">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{getLanguage["QRC"]["WSMA"]}}</label>
                                                <small class="d-block">{{getLanguage["QRC"]["WSMAD"]}}</small>
                                            </CCol>
                                            <CCol col="5">
                                                <div style="display: grid; grid-template-columns: auto auto;">
                                                    <div style="display: flex; align-items: center; gap: 5px">
                                                        <div class="inline">
                                                            <div class="d-flex">
                                                                <input type="checkbox" v-model="bool_obj_qrDBL" id="bool_obj_qrDBL" />
                                                                <label class="searchLabel ml-1" for="bool_obj_qrDBL">{{getLanguage["PV"]["DBL"]}}</label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div style="display: flex; align-items: center; gap: 5px">
                                                        <div class="inline">
                                                            <div class="d-flex">
                                                                <input type="checkbox" v-model="bool_obj_qrDAL" id="bool_obj_qrDAL" />
                                                                <label class="searchLabel ml-1" for="bool_obj_qrDAL">{{getLanguage["PV"]["DAL"]}}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["QRC"]["QRCN"]}}<span class="required" /> </label>
                                            </CCol>
                                            <CCol col="5">
                                                <CInput vertical
                                                        size="sm"
                                                        :value="obj_qr.QRN"
                                                        @change="v => obj_qr.QRN = v"
                                                        ref="QRN" />
                                                <span class="ErrMsg">{{ ValidationErrMsg('QRN','QRCN') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["QRC"]["QRCURL"]}}<span class="required" /> </label>
                                            </CCol>
                                            <CCol col="5">
                                                <CInput vertical size="sm"
                                                        :value="obj_qr.U"
                                                        @change="v => obj_qr.U = v"
                                                        :disabled="obj_qr.QRT > 3"
                                                        ref="U" />
                                                <span class="ErrMsg">{{ ValidationErrMsg('U','QRUR') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["QRC"]["R"]}} </label>
                                            </CCol>
                                            <CCol col="5">
                                                <textarea vertical="" rows="6" class="form-control form-control-sm" :value="obj_qr.R" @change="TextValueChange('R',$event)" v-shortkey.avoid />
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">
                                                    {{getLanguage["QRC"]["I"]}} <span class="text-danger">({{getLanguage["RIZ"]["IZ"]}} 100 X 100)</span><span class="required" />
                                                </label>
                                                <img :class="qrcodeOrientation" :src="qrcodePreview" />
                                            </CCol>
                                            <CCol col="5">
                                                <div class="PopUpActions">
                                                    <input class="PopUpActions-fileInput" id="validatedCustomFile" type="file" name="pic" accept="image/*" @change="onFileSelected" required>
                                                    <label for="validatedCustomFile" class="PopUpActions-filePicker" v-if="selectedFile === null">
                                                        <i class="fa-solid fa-image mr-3"></i> Choose Photo
                                                    </label>
                                                    <label for="validatedCustomFile" class="PopUpActions-filePicker" v-else>
                                                        {{selectedFile.name}}
                                                    </label>
                                                    <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                    <div class="PopUpActions-divider">
                                                        <span class="PopUpActions-divider--line"></span>or
                                                        <span class="PopUpActions-divider--line"></span>
                                                    </div>
                                                    <div class="PopUpActions-textPicker">
                                                        <input type="url" class="form-control" :placeholder="getLanguage['CTAB']['U']" v-model="obj_qr.QRByLink" @change="selectedFile = null;qrcodeOrientation=null;qrcodePreview=obj_qr.QRByLink;checkImageOrientation();">
                                                    </div>
                                                </div>
                                                <!--<span class="ErrMsg">{{ ValidationPromotionCMSErrMsg('PMIU', 'DPMIMG') }}</span>-->
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3" v-if="obj_qr['QRT'] == 0 || obj_qr['QRT'] == 1 || obj_qr['QRT'] == 4">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">
                                                    {{getLanguage["MAPP"]["SDI"]}}
                                                </label>
                                                <img :class="appOrientation" :src="appPreview" />
                                            </CCol>
                                            <CCol col="5">
                                                <div class="PopUpActions">
                                                    <input class="PopUpActions-fileInput" id="validatedCustomFile2" type="file" name="pic" accept="image/*" @change="onFileIcoSelected" required>
                                                    <label for="validatedCustomFile2" class="PopUpActions-filePicker" v-if="selectedFileIco === null">
                                                        <i class="fa-solid fa-image mr-3"></i> Choose Photo
                                                    </label>
                                                    <label for="validatedCustomFile2" class="PopUpActions-filePicker" v-else>
                                                        {{selectedFileIco.name}}
                                                    </label>
                                                    <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                    <div class="PopUpActions-divider">
                                                        <span class="PopUpActions-divider--line"></span>or
                                                        <span class="PopUpActions-divider--line"></span>
                                                    </div>
                                                    <div class="PopUpActions-textPicker">
                                                        <input type="url" class="form-control" :placeholder="getLanguage['CTAB']['U']" v-model="obj_qr.ICONByLink" @change="selectedFileIco = null;appOrientation=null;appPreview=obj_qr.ICONByLink;checkImageOrientation2();">
                                                    </div>
                                                </div>
                                                <!--<span class="ErrMsg">{{ ValidationPromotionCMSErrMsg('PMIU', 'DPMIMG') }}</span>-->
                                            </CCol>
                                        </CRow>
                                    </template>                            
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-success" size="sm" @click="saveQRCode()">
                                        <span class='fa fa-save mr-2'></span>
                                        {{ getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_fullPreview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd1">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content text-center">
                                    <img :src="previewUrl" class="img-fluid" v-if="previewUrl">
                                    <p v-else>{{this.getLanguage['GL']['NR']}}</p>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{getLanguage["QRC"]["QRC"]}}</h2>
                        <CButton size="sm"
                                 color="outline-info"
                                 @click="addQRCode()"
                                 v-if="checkModuleAccess2(constAccessType.add)">
                            <span class="plusIcon cil-plus"></span>
                            {{getLanguage["BTN"]["AN"]}}
                        </CButton>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>

                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <label class=" searchLabel">{{this.getLanguage["DM"]["AGI"]}} :</label>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroupfs"
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="dd_DefaultSubBrand"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            v-model="str_FV[6].FV"
                                            openDirection="below"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{getLanguage["QRC"]["S"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="arry_status"
                                            :placeholder="this.utilGetDDLanguage('QRC.S')"
                                            v-model="str_FV[5].FV" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{getLanguage["QRC"]["D"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_dofs"
                                            :placeholder="this.utilGetDDLanguage('QRC.D')"
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            v-model="str_FV[1].FV" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{getLanguage["QRC"]["L"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_languagefs"
                                            :placeholder="this.utilGetDDLanguage('QRC.L')"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :defaultExpandLevel="Infinity"
                                            v-model="str_FV[3].FV"
                                            :limit="1"
                                            :limitText="count => `+${count}`">

                                </treeselect>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{getLanguage["QRC"]["T"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_qrt"
                                            :placeholder="this.utilGetDDLanguage('QRC.T')"
                                            v-model="str_FV[4].FV" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{getLanguage["QRC"]["QRCL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{getLanguage["QRC"]["S"]}} <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                                <th>{{getLanguage["CU"]["DN"]}}<i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i></th>
                                <th>{{getLanguage["QRC"]["L"]}}</th>
                                <th>{{getLanguage["QRC"]["T"]}}<i @click="setSortTable('QRT')" :class="setSortLogo('QRT')" class="sortlogo"></i></th>
                                <th>{{getLanguage["QRC"]["QRCN"]}}</th>
                                <th>{{getLanguage["QRC"]["URL"]}}</th>
                                <th>{{getLanguage["QRC"]["QRUR"]}}</th>
                                <th>{{getLanguage["QRC"]["APIURL"]}}</th>
                                <th>{{getLanguage["QRC"]["R"]}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{getLanguage["QRC"]["S"]}} <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                                <th>{{getLanguage["CU"]["DN"]}}<i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i></th>
                                <th>{{getLanguage["QRC"]["L"]}}</th>
                                <th>{{getLanguage["QRC"]["T"]}}<i @click="setSortTable('QRT')" :class="setSortLogo('QRT')" class="sortlogo"></i></th>
                                <th>{{getLanguage["QRC"]["QRCN"]}}</th>
                                <th>{{getLanguage["QRC"]["URL"]}}</th>
                                <th>{{getLanguage["QRC"]["QRUR"]}}</th>
                                <th>{{getLanguage["QRC"]["APIURL"]}}</th>
                                <th>{{getLanguage["QRC"]["R"]}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_qr.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_qr" v-bind:key="index">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">
                                <span id="actionBtnCol">
                                    <div v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom_tooltip">
                                        <i class="cil-trash" @click="removeQRCode(data)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)" class="custom_tooltip">
                                        <i class="cil-trash"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom_tooltip">
                                        <i class="cil-color-border" @click="editQRCode(data.I)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)" class="custom_tooltip">
                                        <i class="cil-color-border"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td>
                                <label class="switch">
                                    <input type="checkbox" v-if="data.RS == '2'" checked @change="saveQRStatus(data, 1)" :id="index" :disabled="!checkModuleAccess2(constAccessType.edit)">
                                    <input type="checkbox" v-else @change="saveQRStatus(data, 2)" :id="index" :disabled="!checkModuleAccess2(constAccessType.edit)">
                                    <span class="slider round" :style="disabledPointer()"></span>
                                </label>
                            </td>
                            <td>{{ data.DN }}</td>
                            <td><span class="grid-line" v-for="lang in data.Languages">{{ lang }}</span></td>
                            <td>{{ getQRT(data.QRT) }}</td>
                            <td>{{ substrContent(data.QRN, 30) }}</td>
                            <td>
                                <a :href="data.U" target="_blank" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">{{ substrContent(data.U, 30) }}</a>
                                <a v-if="(isSENS == 1 && data.AGI != curAGI)">{{ substrContent(data.U, 30) }}</a>
                            </td>
                            <td>
                                <a href="javascript:void(0)" style="color:blue" @click="setPreview(data.QRI)" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                    <u>{{getLanguage["GL"]["P"]}}</u>
                                </a>
                                <a href="javascript:void(0)" style="color:blue" v-if="(isSENS == 1 && data.AGI != curAGI)">
                                    <u>{{getLanguage["GL"]["P"]}}</u>
                                </a>
                            </td>
                            <td>
                                <a href="javascript:void(0)" style="color:blue" @click="setPreview(data.AI)" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                    <u>{{getLanguage["GL"]["P"]}}</u>
                                </a>
                                <a href="javascript:void(0)" style="color:blue" v-if="(isSENS == 1 && data.AGI != curAGI)">
                                    <u>{{getLanguage["GL"]["P"]}}</u>
                                </a>
                            </td>
                            <td>{{ substrContent(data.R, 30) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/antd.css'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import { mapGetters, mapActions } from 'vuex'
    import genericHelper from "@/modules/GenericHelper.js";
    import { required, minLength, between, url } from 'vuelidate/lib/validators';
    import { constAccessType, constStatus, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components:
        {
            VueSlider,
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                bool_isAMV: false, // Add Modal Visible
                bool_statusLock: true,
                int_lblPage: 1,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                bool_statusLock: true,
                bool_fullPreview: false,
                timeout: null,
                //the parameter of getList()
                int_Page: 1,//current Pagr
                int_IC: 1, // Item Count
                int_RC: 100, //Row Count
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                str_FV: [{ F: "AGI" }, { F: "DI" }, { F: "CTS", FV: { startDate: "", endDate: "" } }, { F: "L_csv", FA: true }, { F: "QRT" }, { F: "RS" }, { F: "SAGAGI" }], //Filter Value
                //ctrl Page valuev (A return Data )
                int_TI: 0,//Total Items
                int_TP: 1, //Total Page
                //array hold data
                newImg: false,
                newIcon: false,
                isEdit: true,
                selectedFile: null,
                selectedFileIco: null,
                qrcodeOrientation: null,
                appOrientation: null,
                qrcodePreview: null,
                appPreview: null,

                bool_CV: false, // Check Validation
                dd_language: [], //Language Array
                dd_languagefs: [], //Language Array
                dd_agentgroup: [],
                dd_agentgroupfs: [],
                dd_subagentgroup: [], //subagent group option

                dd_do: [],
                dd_qrt: [
                    { id: '0', label: 'Android' },
                    { id: '1', label: 'IOS' },
                    { id: '2', label: 'WeChat' },
                    { id: '3', label: 'Line' }
                    /*{ id: '4', label: 'Smart QR Code'}*/
                ],//qr code type
                dd_dofs: [],
                arry_qr: [], //QRCode List
                obj_qr: {
                    I: 0,
                    RS: 2,
                    SD: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AGI: null,
                    AGIT: null,
                    QRN: null,
                    U: null,
                    L: "",
                    QRT: null,
                    R: null,
                    QRI: "",
                    DI: null,
                    QRByLink: "",
                    ICONByLink: null,
                    DN: "",
                    arry_holdLang: null,
                    IUT: false,
                    AUT: false,
                    AI: null,
                    SAGAGI: null
                }, //Add QRCode
                bool_obj_qrRS: true,
                bool_obj_qrSD: true,
                bool_obj_qrDBL: true,
                bool_obj_qrDAL: true,
                arry_status: [],
                constAccessType: constAccessType,
                previewUrl: null,
                dd_DefaultSubBrand: [],
                rtSubBrand: 0,
                bool_showBI: true,
                bool_showSMA: true,
                sqrcu: ""
            }
        },
        validations: {
            selectedFile: { required },
            obj_qr: {
                U: { required },
                DI: { required },
                QRT: { required },
                QRN: { required },
                AGIT: { required },
                arry_holdLang: { required },
            }
        },
        computed: {
            ...mapGetters("Language", ["getLanguage"]),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        watch: {
            bool_obj_qrRS(newValue) {
                if (newValue == true) {
                    this.obj_qr["RS"] = "2"
                    if (this.obj_qr["QRT"] == 0 || this.obj_qr["QRT"] == 1) {
                        this.bool_obj_qrDBL = true;
                        this.bool_obj_qrDAL = true;
                        this.obj_qr['DBL'] = 1;
                        this.obj_qr['DAL'] = 1;
                        this.obj_qr['SD'] = 2;
                    }
                } else {
                    this.obj_qr["RS"] = "1";
                    this.bool_obj_qrDBL = false;
                    this.bool_obj_qrDAL = false;
                    this.obj_qr['DBL'] =  0;
                    this.obj_qr['DAL'] =  0;
                    this.obj_qr['SD'] =  1;
                }
            },
            bool_obj_qrSD(newValue) {
                if (newValue == true) {
                    this.obj_qr["SD"] = "2"
                } else {
                    this.obj_qr["SD"] = "1"
                }
            },         
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getQRCodeList();
                this.getStatus();
            },
        },
        created() {
            this.$parent.showSubMenu = 'CMS';
            this.$parent.showActiveMenu = 'CMS.QRC';
            if (this.$route.path == '/WEBS/QRC') {
                this.$parent.showSubMenu = 'WEBS';
                this.$parent.showSubSubMenu = 'CMS1';
                this.$parent.showActiveMenu = 'WEBS.QRC';
            }
            if (this.getUserInfo.AT == 4) {
                this.getSubAgentGroup(0, true);
            }
            else {
                this.getQRCodeList();
            }
            //this.getQRCodeList();
            this.getDropdownList();
            this.getStatus();
            this.getSmartQRCodeUrl();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;

        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[2].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[2].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[2].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[2].FV.endDate = "";
                    }
                }
            },
            TextValueChange(type, event) {
                if (type == "R") {
                    this.obj_qr.R = event.target.value;
                }
            },
            closeAdd() {
                this.selectedFile = null;
                this.selectedFileIco = null;
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            closeAdd1() {
                this.previewUrl = null;
                this.bool_fullPreview = !this.bool_fullPreview;
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('QRC', 'CMS', type);
            },
            getStatus() {
                this.arry_status = [{ id: '1', label: this.getLanguage['GL']['DISB'] }, { id: '2', label: this.getLanguage['GL']['ENB'] }];
            },
            renderStatus(index) {
                return this.arry_status[index - 1].label;
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getQRCodeList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getQRCodeList();
                }
            },
            //AgentGroupChangefs(value) {

            //    if (value != undefined) {
            //        var that = this;
            //        var agi = 0;

            //        if (value != "") {
            //            agi = value.split("-")[1];
            //        }
            //        this.getDataApi(`/api/dd/dn/` + agi,
            //            function (d, s) {
            //                if (s) {
            //                    that.dd_dofs = d.dropdownlist
            //                    that.str_FV[0].FV = agi;
            //                }
            //            });
            //    }
            //    else {
            //        this.str_FV[0].FV = null;
            //    }
            //},
            AgentGroupChange(value) {
                if (value != undefined) {
                    if (this.obj_qr['I'] == 0)
                        this.obj_qr['DI'] = null;
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                        this.obj_qr.AT = value.split("-")[0];

                    }

                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {

                            that.dd_do = d.dropdownlist;
                            that.obj_qr.SAGAGI = null;

                            // if (s && that.bool_isAMV) {
                            //     that.dd_do = d.dropdownlist
                            // } else if (s && that.bool_isAMV == false) {
                            //     that.dd_do = d.dropdownlist
                            // }
                        });
                }
            },
            AgentGroupChangefs(value) {
                this.str_FV[6].FV = null;
                var that = this;
                if (value) {
                    var agi = 0;
                    if (value != "")
                        agi = value.split("-")[1];
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                            }
                        });
                    that.str_FV[0].FV = agi;
                }
                else {
                    that.dd_dofs = [];
                    that.str_FV[0].FV = null;
                    this.str_FV[6].FV = null;
                }
                that.str_FV[1].FV = null;
            },

            SubAgentGroupChange(value) {
                if (this.obj_qr['I'] == 0) {
                    this.obj_qr['DI'] = null;
                }
                this.dd_do = [];
                var that = this;
                var agi = 0;

                if (value) {
                    agi = value;
                    this.obj_qr.AT = 4;

                    this.getDataApi(`/api/dd/dn-sag/` + agi,
                        function (d, s) {
                            if (s && d) {
                                that.dd_do = d.dropdownlist
                            }
                        });
                } else {
                    agi = this.obj_qr.AGIT.split("-")[1];
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s && d) {
                                that.dd_do = d.dropdownlist;
                                that.obj_qr.SAGAGI = null;
                            }
                        });
                }
            },
            SubAgentGroupChangefs(value) {
                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value;
                    }
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                                //that.str_FV[0].FV = agi;
                            }
                        });
                }
                else {
                    this.str_FV[6].FV = null;
                    this.dd_dofs = [];
                }
                this.str_FV[1].FV = null;

            },
            DomainChange(value) {
                var that = this;
                if (value && value > 0) {
                    // this.getDataApi(`/api/dd/dlang/` + value, function (d, s) {
                    //     if (s) {
                    //         that.dd_language = that.appendSelectAllOption(d.dropdownlist);
                    //     }
                    // });
                    if (that.obj_qr.SAGAGI) {
                        this.getDataApi(`/api/dd/dlang-sub/` + value, function (d, s) {
                            if (s) {
                                that.dd_language = that.appendSelectAllOption(d.dropdownlist);
                            }
                        });
                    } else {
                        this.getDataApi(`/api/dd/dlang/` + value, function (d, s) {
                            if (s) {
                                that.dd_language = that.appendSelectAllOption(d.dropdownlist);
                            }
                        });
                    }
                }
                else {
                    that.dd_language = [];
                }
                if (that.obj_qr.I == 0)
                    that.obj_qr.arry_holdLang = [];
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;

                if (this.obj_qr['AGIT'] && this.bool_isAMV) {
                    var agentList = this.obj_qr['AGIT'].split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.str_FV[0].FV && !this.bool_isAMV) {
                    var agentList = this.str_FV[0].FV.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            //DomainChangefs(value) {
            //    var that = this;
            //    if (value && value > 0) {
            //        this.getDataApi(`/api/dd/dlang/` + value, function (d, s) {
            //            if (s) {
            //                that.dd_languagefs = that.appendSelectAllOption(d.dropdownlist);
            //            }
            //        });
            //    }
            //    else {
            //        that.dd_languagefs = [];
            //    }
            //    that.str_FV[3].FV = [];
            //},
            getSubAgentGroup(value, isFirstLoad = false) {
                var that = this;
                this.getDataApi(`/api/dd/subbrand/0/0/${value}/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_DefaultSubBrand = that.deepClone(d.dropdownlist);

                            if (isFirstLoad) {
                                that.str_FV[4].FV = that.dd_DefaultSubBrand[0].id;
                                that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                                that.getQRCodeList();
                            }
                        }
                    });
            },
            getQRT(type) {
                var result = "";
                try {
                    result = this.dd_qrt[type]["label"];
                }
                catch (ex) {
                    //console.log(ex);
                }
                return result;
            },
            getDropdownList() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
                this.getDataApi(`/api/dd/lang/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_languagefs = that.appendSelectAllOption(d.dropdownlist);
                        }

                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            onFileSelected(event) {
                this.obj_qr['QRByLink'] = null;
                this.selectedFile = this.validateFile(event);
                this.newImg = true;

                const file = event.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.qrcodePreview = e.target.result;
                        this.checkImageOrientation();
                    };
                    reader.readAsDataURL(file);
                } else {
                    this.qrcodePreview = null;
                }
            },
            onFileIcoSelected(event) {
                this.obj_qr['ICONByLink'] = null;
                this.selectedFileIco = this.validateFile(event);
                this.newIcon = true;

                const file = event.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.appPreview = e.target.result;
                        this.checkImageOrientation2();
                    };
                    reader.readAsDataURL(file);
                } else {
                    this.appPreview = null;
                }
            },
            checkImageOrientation() {
                const img = new Image();
                img.onload = () => {
                    if (img.width > img.height) { //landscape
                        this.qrcodeOrientation = 'previewImg landscape';
                    } else if (img.width < img.height) { //portrait
                        this.qrcodeOrientation = 'previewImg portrait';
                    } else if (img.width == img.height) { //square
                        this.qrcodeOrientation = 'previewImg square';
                    }
                };
                img.src = this.qrcodePreview;
            },
            checkImageOrientation2() {
                const img = new Image();
                img.onload = () => {
                    if (img.width > img.height) { //landscape
                        this.appOrientation = 'previewImg landscape';
                    } else if (img.width < img.height) { //portrait
                        this.appOrientation = 'previewImg portrait';
                    } else if (img.width == img.height) { //square
                        this.appOrientation = 'previewImg square';
                    }
                };
                img.src = this.appPreview;
            },
            getQRCodeList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV && i != 0 && i != 6) { // here need exclude agi & subAGI
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "&f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };
                if (this.str_FV[6].FV) {
                    path += "&f[AGI]=" + this.str_FV[6].FV;
                } else if (this.str_FV[0].FV) {
                    path += "&f[AGI]=" + this.str_FV[0].FV;
                }
                this.getDataApi(`/api/qrcode/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setQRCodeList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setQRCodeList(data) {
                this.arry_qr = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            addQRCode() {
                this.obj_qr = {
                    I: 0,
                    RS: 2,
                    SD: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AGI: null,
                    AGIT: null,
                    QRN: null,
                    U: null,
                    L: "",
                    R: null,
                    QRT: null,
                    QRI: "",
                    DI: null,
                    DN: "",
                    arry_holdLang: null,
                    IUT: false,
                    AUT: false,
                    AI: null,
                    ARI: null
                };
                this.bool_obj_qrRS = this.returnStatus();
                this.bool_obj_qrSD = this.returnStatus1();
                this.bool_obj_qrDBL = this.returnDisplayBeforeLoginStatus();
                this.bool_obj_qrDAL = this.returnDisplayAfterLoginStatus();
                this.selectedFile = null;
                this.selectedFileIco = null;
                this.qrcodeOrientation = null;
                this.appOrientation = null;
                this.qrcodePreview = null;
                this.appPreview = null;

                this.bool_CV = false;
                this.newImg = false;
                this.newIcon = false;
                this.isEdit = false;
                this.bool_isAMV = true;

                if (this.getUserInfo.AT === 4) {
                    this.getSubAgentGroup(0, true);
                }
                else {
                    this.dd_DefaultSubBrand = [];
                }

                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.obj_qr.AGIT = this.dd_agentgroup[0].id;
                        this.AgentGroupChange(this.obj_qr.AGIT);
                    }
                }
            },         
            editQRCode(id) {
                this.bool_fullLoading = true;
                this.isEdit = true;
                this.newImg = false;
                this.newIcon = false;
                this.selectedFile = null;
                this.selectedFileIco = null;
                this.qrcodeOrientation = null;
                this.appOrientation = null;
                this.qrcodePreview = null;
                this.appPreview = null;
                var that = this;
                this.getSubAgentGroup(0)

                this.getDataApi(`/api/qrcode/g/${id}`,
                    function (d, s) {
                        if (s) {
                            that.setQRCode(d.D);
                            that.bool_fullLoading = false;
                            // if (that.obj_qr.AGI != 0) {
                            //     that.obj_qr.AGIT = "3-" + that.obj_qr.AGI;
                            //     that.AgentGroupChange(that.obj_qr.AGIT);
                            // }
                            if (that.obj_qr.AGI != 0) {
                            var tempSAGAGI = that.obj_qr.SAGAGI;  //keep sagagi because when AgentGroupChange will assign null
                            that.obj_qr.AGIT = "3-" + that.obj_qr.AAGI;
                                if (tempSAGAGI > 0) {
                                    that.SubAgentGroupChange(tempSAGAGI);
                                    that.obj_qr.SAGAGI = tempSAGAGI;
                                } else {
                                    that.AgentGroupChange(that.obj_qr.AGIT);
                                    that.obj_qr.SAGAGI = null;
                                }
                            }
                            if (that.obj_qr.QRByLink){
                                that.qrcodePreview = that.obj_qr.QRByLink;
                                that.checkImageOrientation();
                            }
                            if (that.obj_qr.ICONByLink) {
                                that.appPreview = that.obj_qr.ICONByLink;
                                that.checkImageOrientation2();
                            }
                            if (that.obj_qr && that.obj_qr.DI) {
                                that.DomainChange(that.obj_qr.DI);
                            }
                        }
                    });
            },

            setQRCode(data) {
                data.QRByLink = data.QRI;
                data.ICONByLink = data.AI;
                this.obj_qr = Object.assign(this.obj_qr, data);
                this.bool_obj_qrRS = this.returnStatus();
                this.bool_obj_qrSD = this.returnStatus1();
                this.bool_obj_qrDBL = this.returnDisplayBeforeLoginStatus();
                this.bool_obj_qrDAL = this.returnDisplayAfterLoginStatus();
                var arry_splitLang = this.obj_qr.L.split(',');
                this.obj_qr.arry_holdLang = arry_splitLang;
                this.DomainChange(data.DI);
                this.bool_isAMV = true;
            },
            returnStatus() {
                if (this.obj_qr["RS"] == 2) {
                    return true;
                } else {
                    return false;
                }
            },
            returnStatus1() {
                if (this.obj_qr["SD"] == 2) {
                    return true;
                } else {
                    return false;
                }
            },
            returnDisplayBeforeLoginStatus() {
                if (this.obj_qr["DBL"] == 1) {
                    return true;
                } else {
                    return false;
                }
            },
            returnDisplayAfterLoginStatus() {
                if (this.obj_qr["DAL"] == 1) {
                    return true;
                } else {
                    return false;
                }
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_qr[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["QRC"][langKey]);
                    }
                    else if (validateObj.url != undefined && !validateObj.url) {
                        return String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["QRC"][langKey]);
                    }
                }

            },
            saveQRCode() {
                this.bool_fullLoading = true;
                this.bool_CV = true;
                this.obj_qr['DBL'] = this.bool_obj_qrDBL ? 1 : 0;
                this.obj_qr['DAL'] = this.bool_obj_qrDAL ? 1 : 0;
                this.obj_qr['SD'] = (this.obj_qr['DBL'] == 0 && this.obj_qr['DAL'] == 0) ? 1 : 2;
                if (this.obj_qr.SAGAGI) {
                    this.obj_qr.AGI = this.obj_qr.SAGAGI;
                }

                if (this.obj_qr.QRByLink != null && this.obj_qr.QRByLink != "") {
                    this.obj_qr.IUT = true;
                } else {
                    this.obj_qr.IUT = false;
                }

                if (this.obj_qr.ICONByLink != null && this.obj_qr.ICONByLink != "") {
                    this.obj_qr.AUT = true;
                } else {
                    this.obj_qr.AUT = false;
                }

                this.$v.obj_qr.$touch();
                if (!this.$v.obj_qr.$error) {
                    this.bool_fullLoading = true;
                    this.obj_qr["L"] = "";
                    for (var i = 0; i < this.obj_qr.arry_holdLang.length; i++) {
                        if (i != 0) {
                            this.obj_qr["L"] += ",";
                        }
                        this.obj_qr["L"] += this.obj_qr.arry_holdLang[i];
                    }
                    //down here for Agi dropdown
                    if (this.obj_qr.AGIT != "") {
                        var agi = this.obj_qr.AGIT.split("-");
                        this.obj_qr.AGI = agi[1];
                        
                    }
                    var that = this;
                    that.bool_fullLoading = false;

                    if (this.newImg == true || this.newIcon == true) {
                        //if new image is selected
                        this.obj_qr['QRCodeImage'] = this.selectedFile;
                        this.obj_qr['AppIconImage'] = this.selectedFileIco;
                        this.bool_fullLoading = true;
                        this.bool_fullScreen = true;                      
                        this.postDataApiWithAttach(`/api/qrcode/s`, this.obj_qr,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                that.bool_fullScreen = false;
                                if (s) {
                                    that.bool_isAMV = false;
                                    that.selectedFile = null;
                                    that.selectedFileIco = null;
                                    that.getQRCodeList();
                                }
                            });

                    } else if (this.newImg == false && this.newIcon == false && this.isEdit == true) {
                        //if user edit, but want to retain image
                        this.bool_fullLoading = true;
                        this.bool_fullScreen = true;
                        this.postDataApi(`/api/qrcode/s`, this.obj_qr,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                that.bool_fullScreen = false;
                                if (s) {
                                    that.bool_isAMV = false;
                                    that.selectedFile = null;
                                    that.selectedFileIco = null;
                                    that.getQRCodeList();
                                }
                            });
                    } else {
                        this.bool_fullLoading = false;
                        this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.4002")));
                    }
                } else {
                    this.bool_fullLoading = false;

                    //get the object for validating.
                    const validation = this.$v["obj_qr"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            removeQRCode(aRow) { //remove
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var obj = {
                            i: aRow.I,
                            uts: aRow.UTS,
                            di: aRow.DI
                        };

                        this.postDataApi(`/api/qrcode/d`, obj,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getQRCodeList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getQRCodeList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            clearDateRangeFilter() {
                this.str_FV[2].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            setPreview(value) {
                this.previewUrl = value;
                this.bool_fullPreview = true;
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            disabledPointer() {
                return (!this.checkModuleAccess2(constAccessType.edit)) ? "cursor:not-allowed; filter:none" : "";
            },
            saveQRStatus(data, status) {
                this.bool_fullLoading = true;
                this.bool_fullScreen = true;

                var that = this;
                var obj = {
                    I: data.I,
                    UTS: data.UTS,
                    DI: data.DI,
                    RS: status
                };

                this.postDataApi(`/api/qrcode/t`, obj,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        that.bool_fullScreen = false;
                        if (s) {
                            that.getQRCodeList();
                        }
                    });
            },
            showSectionBasedRole(type) {
                var that = this;
                if (type == 'bi') {
                    this.bool_showBI = (this.bool_showBI ? this.bool_showBI = false : this.bool_showBI = true);
                }
                if (type == 'sma') {
                    this.bool_showSMA = (this.bool_showSMA ? this.bool_showSMA = false : this.bool_showSMA = true);
                }
            },
            setCollapseExpandIcon(settingType) {
                if (settingType == 'BI') {
                    if (this.bool_showBI) {
                        return "chevron-container chevron-up";
                    } else if (!this.bool_showBI) {
                        return "chevron-container";
                    }
                } else if (settingType == 'SMA') {
                    if (this.bool_showSMA) {
                        return "chevron-container chevron-up";
                    } else if (!this.bool_showSMA) {
                        return "chevron-container";
                    }
                }
            },
            qrcodeChange(value) {
                var that = this;
                that.obj_qr.U = "";
                console.log(value);
                if (value == 4) {
                    var prefixcode = "";
                    var agi = 0
                    if (this.obj_qr.AGIT != "") {
                        agi = this.obj_qr.AGIT.split("-")[1];
                    }
                    this.getDataApi(`/api/ag/agpc/` + agi,
                        function (d, s) {
                           if (s) {
                               that.obj_qr.U = that.sqrcu + "/qrcoderedirect/" + d;
                           }
                        });
                    
                }
            },
            getSmartQRCodeUrl() {
                var that = this;
          
                this.getDataApi(`/api/qrcode/gsqrcu`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            console.log(d);
                            that.sqrcu = d;
                        }
                    });
            },
        }
    }
</script>

<style scoped>
    #QRcodeS .row.mx-3 {
        padding: 10px 0px;
        border-top: solid 1px rgba(0,0,21,.2);
        border-bottom: solid 1px rgba(0,0,21,.2);
    }

        #QRcodeS .row.mx-3:hover {
            background: rgb(207 207 207 / 80%);
            border-top: solid 1px #909090;
            border-bottom: solid 1px #909090;
        }

    #QRcodeS .col-7 label {
        width: 100%;
        padding-top: 0px;
    }

        #QRcodeS .col-7 label::after {
            content: ":";
            float: right;
        }

    #QRcodeS .promotion-game-list input[type="checkbox"] {
        margin: 0;
    }

    #QRcodeS .ErrMsg {
        font-weight: 600;
        font-family: "IBM Plex Sans", "Inconsolata Monospace", Calibri, "Open Sans", sans-serif;
    }

    .PopUpActions {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

        .PopUpActions * {
            color: #000;
            font-size: 12px;
            letter-spacing: .02em;
            font-weight: bold;
        }

        .PopUpActions button, .PopUpActions a {
            border: 0;
            background: 0 0;
            cursor: pointer;
            outline: 0
        }

    .PopUpActions-picsart {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 1207
    }

        .PopUpActions-picsart iframe {
            border: 0
        }

    .PopUpActions-fileInput {
        opacity: 0;
        position: absolute;
        z-index: -1
    }

    .PopUpActions-filePicker, .PopUpActions-textPicker input, .PopUpActions-extra button, .PopUpActions-extra a {
        transition: opacity .3s,border .5s
    }

        .PopUpActions-filePicker:hover, .PopUpActions-textPicker input:hover, .PopUpActions-extra button:hover, .PopUpActions-extra a:hover {
            opacity: .75
        }

    .PopUpActions-filePicker {
        height: 25px;
        cursor: pointer
    }

        .PopUpActions-filePicker img {
            margin-right: 10px
        }

    .PopUpActions-divider {
        height: 10px;
        margin-top: 5px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
    }

    .PopUpActions-divider--line {
        width: 40px;
        height: 1px;
        margin: 0 16px;
        background-color: #000;
        opacity: .12
    }

    .PopUpActions-textPicker {
        height: 25px;
        max-width: 320px;
        /* margin-bottom:48px; */
    }

        .PopUpActions-textPicker input {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 3px;
            text-align: center;
            background-color: #272a33;
            border: unset;
            outline: unset;
            border: 1px solid transparent;
            color: #fff;
        }

            .PopUpActions-textPicker input::placeholder {
                color: #fff
            }

            .PopUpActions-textPicker input::-ms-input-placeholder {
                color: #fff
            }

            .PopUpActions-textPicker input:hover {
                border: 1px solid;
                opacity: .75;
                border: 1px solid rgba(200,191,255,.5)
            }

            .PopUpActions-textPicker input:focus {
                opacity: 1;
                border: 1px solid #c8bfff
            }

                .PopUpActions-textPicker input:focus::placeholder {
                    opacity: 0
                }

                .PopUpActions-textPicker input:focus::-webkit-input-placeholder {
                    opacity: 0
                }

                .PopUpActions-textPicker input:focus:-moz-placeholder {
                    opacity: 0
                }

                .PopUpActions-textPicker input:focus::-moz-placeholder {
                    opacity: 0
                }

                .PopUpActions-textPicker input:focus:-ms-input-placeholder {
                    opacity: 0
                }

    .previewImg.landscape {
        width: 300px;
        height: auto;
    }

    .previewImg.portrait {
        width: auto;
        height: 300px;
    }

    .previewImg.square {
        width: 150px;
        height: 150px;
    }

</style>



// WEBPACK FOOTER //
// src/components/SideMenu/ContentManagementSystem/QRcode.vue